import React, { useEffect, useMemo, useState } from "react";

import api, { IMAGE_BASE_URL } from "../api/Api.js";
import { useNavigate } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/style.css";

import { useLanguage } from "../context/LanguageContext.jsx";

import tickImage from "../assets/images/tickm.png";
import insuranceicon from "../assets/images/insurances-icon.png";
import babyseat from "../assets/images/baby-seat1.png";
import creditCard from "../assets/images/credit-card.png";
import cash from "../assets/images/cash.png";
import smoking from "../assets/images/smoking.png";
import driver from "../assets/images/driver.png";
import lmap from "../assets/images/lmap.png";
import darrow from "../assets/images/darrow.png";
import loderImage from "../assets/loder-image1.gif";

// ============================================================
// EXTRA ICONS
// ============================================================
const extraIcons = {
  15: creditCard,
  14: cash,
  8: smoking,
  12: driver,
};

const defaultIcon = "images/default-extra.png";

// ============================================================
// COMPONENT
// ============================================================

function BookACarThree() {
  const navigate = useNavigate();

  const { language, t } = useLanguage();

  // ==========================================================
  // LANGUAGE
  // ==========================================================

  const languageId = Number(language?.lang_id || 1);

  // ==========================================================
  // TRANSLATION HELPERS
  // ==========================================================

  const bt = (key, fallback = "") => {
    return t(`bookingengine.${key}`, fallback);
  };

  const pt = (key, fallback = "") => {
    return t(`personaldtls.${key}`, fallback);
  };

  const rt = (key, fallback = "") => {
    return t(`ratechart.${key}`, fallback);
  };

  const et = (key, fallback = "") => {
    return t(`extracharges.${key}`, fallback);
  };

  // ==========================================================
  // STATE
  // ==========================================================

  const [car, setCar] = useState(null);

  // Selected car in the CURRENT language (name / category)
  const [translatedCar, setTranslatedCar] = useState(null);

  const [bookingCriteria, setBookingCriteria] = useState(null);

  // ==========================================================
  // MODIFY BOOKING
  // ==========================================================

  const [showModifyForm, setShowModifyForm] = useState(false);

  const [modifyForm, setModifyForm] = useState(null);

  const [loading, setLoading] = useState(true);

  // ==========================================================
  // COUPON STATE
  // ==========================================================

  const [couponCode, setCouponCode] = useState("");

  const [couponLoading, setCouponLoading] = useState(false);

  const [couponMessage, setCouponMessage] = useState("");

  const [couponError, setCouponError] = useState("");

  // Actual discount amount in €
  const [couponDiscount, setCouponDiscount] = useState(0);

  // Percentage returned by coupon
  const [couponDiscountPercentage, setCouponDiscountPercentage] = useState(0);

  // Applied coupon object
  const [appliedCoupon, setAppliedCoupon] = useState(null);

  // ==========================================================
  // EXTRAS
  // ==========================================================

  const [freeExtras, setFreeExtras] = useState([]);

  const [paidExtras, setPaidExtras] = useState([]);
  const [showModal, setShowModal] = useState(false); // 1416
  const [selectedItem, setSelectedItem] = useState(null); // 1416

  // ==========================================================
  // INSURANCE
  // ==========================================================

  const [freeInsurance, setFreeInsurance] = useState([]);

  const [paidInsurance, setPaidInsurance] = useState([]);

  // ==========================================================
  // FREE EXTRA QUANTITIES / CHECKBOXES
  // ==========================================================

  const [selectedFreeExtras, setSelectedFreeExtras] = useState({});

  const [freeExtraChecked, setFreeExtraChecked] = useState({});

  // ==========================================================
  // PAID EXTRA QUANTITIES / CHECKBOXES
  // ==========================================================

  const [selectedPaidExtras, setSelectedPaidExtras] = useState({});

  const [paidExtraChecked, setPaidExtraChecked] = useState({});

  // ==========================================================
  // INSURANCE CHECKBOXES
  // ==========================================================

  const [freeInsuranceChecked, setFreeInsuranceChecked] = useState({});

  const [paidInsuranceChecked, setPaidInsuranceChecked] = useState({});

  // ==========================================================
  // CUSTOMER INFORMATION
  // ==========================================================

  const [customer, setCustomer] = useState({
    title: "Mr", // default matches the first option shown in the dropdown
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    phone: "",
    mobile: "",
    address: "",
    city: "",
    country: "",
    postcode: "",
    remarks: "",
    dropoffRemarks: "",
  });

  // REGULAR CLIENT (saved by BookACar.jsx after verification)
  const [regularClient, setRegularClient] = useState(null);

  // ==========================================================
  // PAYMENT / TERMS
  // ==========================================================

  const [paymentMethod, setPaymentMethod] = useState("paynow");

  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const [submitting, setSubmitting] = useState(false);

  // ==========================================================
  // TERMS
  // ==========================================================

  const [termsContent, setTermsContent] = useState(null);

  const [termsLoading, setTermsLoading] = useState(false);

  const [showTermsModal, setShowTermsModal] = useState(false);

  const [locations, setLocations] = useState([]); // CODE-1416
  const [loadingLocations, setLoadingLocations] = useState(false); // CODE-1416
  const [countries, setCountries] = useState([]); // CODE-1416

  // =====================================================
  // FETCH LOCATIONS // CODE-1416
  // =====================================================

  useEffect(() => {
    fetchLocations();
  }, [languageId]);

  const fetchLocations = async () => {
    try {
      setLoadingLocations(true);

      const response = await api.get("/locations/getLocations", {
        params: {
          city_id: 1,
          lang_id: languageId,
        },
      });

      const result = response.data;

      if (result && result.success && Array.isArray(result.data)) {
        setLocations(result.data);
      } else {
        console.warn("Invalid location response:", result);

        setLocations([]);
      }
    } catch (error) {
      console.error("LOCATION API ERROR:", error);

      setLocations([]);
    } finally {
      setLoadingLocations(false);
    }
  };

  // =====================================================
  // LOCATION NAME  // CODE-1416
  // =====================================================

  const getLocationName = (locId) => {
    const found = locations.find((loc) => String(loc.loc_id) === String(locId));

    return found ? found.loc_name : "";
  };

  // =====================================================
  // FETCH Country // CODE-1416
  // =====================================================

  useEffect(() => {
    getCountries();
  }, []);

  const getCountries = async () => {
    try {
      const response = await api.get("/locations/getCountry", {
        params: {
          lang_id: 1,
        },
      });

      if (response.data.success) {
        setCountries(response.data.data || []);
      }
    } catch (error) {
      console.error("Country loading error:", error);
    }
  };

  // ==========================================================
  // LOAD TERMS
  // ==========================================================

  useEffect(() => {
    const loadTermsAndConditions = async () => {
      try {
        setTermsLoading(true);

        const response = await api.get("/contents/content", {
          params: {
            page_id: 20,
            lang_id: languageId,
          },
        });

        const result = response.data;

        if (!result || !result.success || !result.data) {
          setTermsContent(null);
          return;
        }

        setTermsContent(result.data);
      } catch (error) {
        console.error("ERROR LOADING TERMS:", error);

        setTermsContent(null);
      } finally {
        setTermsLoading(false);
      }
    };

    loadTermsAndConditions();
  }, [languageId]);

  // ==========================================================
  // CUSTOMER CHANGE
  // ==========================================================

  const handleCustomerChange = (e) => {
    const { name, value } = e.target;
    setCustomer((previous) => ({
      ...previous,
      [name]: value,
    }));
  };

  // ==========================================================
  // REGULAR CLIENT AUTO-FILL
  // Reads sessionStorage.regularClient (set in BookACar.jsx)
  // ==========================================================

  useEffect(() => {
    try {
      const stored = sessionStorage.getItem("regularClient");
      if (!stored) return;

      const c = JSON.parse(stored);
      setRegularClient(c);

      const txt = (v) =>
        v === null || v === undefined ? "" : String(v).trim();

      const email = txt(c.regclient_email) || txt(c.clientemail);

      setCustomer((prev) => ({
        ...prev,
        title: txt(c.regclient_title) || prev.title,
        firstName: txt(c.regclient_name) || prev.firstName,
        lastName: txt(c.regclient_familyname) || prev.lastName,
        email: email || prev.email,
        confirmEmail: email || prev.confirmEmail,
        phone: txt(c.regclient_phoneno) || prev.phone,
        mobile: txt(c.regclient_mobno) || prev.mobile,
        address: txt(c.regclient_streetno) || prev.address,
        city: txt(c.regclient_town) || prev.city,
        postcode: txt(c.regclient_postcode) || prev.postcode,
      }));
    } catch (error) {
      console.error("Error reading regularClient:", error);
    }
  }, []);

  // ==========================================================
  // LOAD BOOKING DATA
  // ==========================================================

  useEffect(() => {
    try {
      const storedCar = sessionStorage.getItem("selectedCar");

      const storedCriteria = sessionStorage.getItem("bookingCriteria");

      if (!storedCar) {
        console.warn("No selected car found");

        navigate("/bookacar");
        return;
      }

      const parsedCar = JSON.parse(storedCar);

      setCar(parsedCar);

      if (storedCriteria) {
        const parsedCriteria = JSON.parse(storedCriteria);

        setBookingCriteria(parsedCriteria);
        setModifyForm({ ...parsedCriteria });
      }
    } catch (error) {
      console.error("Error loading booking information:", error);

      navigate("/bookacar");
    } finally {
      setLoading(false);
    }
  }, [navigate]);

  // ==========================================================
  // LOAD CAR NAME / CATEGORY IN THE CURRENT LANGUAGE
  //
  // The selected car is saved in sessionStorage in the language
  // of the previous page, so it never changes when the language
  // changes. We load the same car again with the current
  // language and use its name / category.
  // ==========================================================

  useEffect(() => {
    if (!car) return;

    const carId =
      car.selectedmodelid || car.carmodel_id || car.car_id || car.id;

    if (!carId) return;

    let cancelled = false;

    const loadCarName = async () => {
      try {
        const response = await api.get("/cars/getCars", {
          params: { lang_id: languageId },
        });

        if (cancelled) return;

        const list =
          response.data?.success && Array.isArray(response.data.data)
            ? response.data.data
            : [];

        const found = list.find(
          (item) =>
            String(item.carmodel_id || item.car_id || item.id) === String(carId)
        );

        console.log("CAR NAME LANGUAGE:", languageId, "CAR ID:", carId, found);

        setTranslatedCar(found || null);
      } catch (error) {
        if (!cancelled) {
          console.error("CAR NAME ERROR:", error);
          setTranslatedCar(null);
        }
      }
    };

    loadCarName();

    return () => {
      cancelled = true;
    };
  }, [car, languageId]);

  // ==========================================================
  // LOAD EXTRAS + INSURANCE
  // ==========================================================

  useEffect(() => {
    const loadExtras = async () => {
      try {
        const response = await api.get("/extras", {
          params: {
            lang_id: languageId,
          },
        });

        const result = response.data;

        if (!result || !result.success) {
          throw new Error(result?.message || "Failed to load extras");
        }

        setFreeExtras(
          Array.isArray(result.freeExtras) ? result.freeExtras : []
        );

        setPaidExtras(
          Array.isArray(result.paidExtras) ? result.paidExtras : []
        );

        setFreeInsurance(
          Array.isArray(result.freeInsurance) ? result.freeInsurance : []
        );

        setPaidInsurance(
          Array.isArray(result.paidInsurance) ? result.paidInsurance : []
        );
      } catch (error) {
        console.error("Error loading extras:", error);

        setFreeExtras([]);
        setPaidExtras([]);
        setFreeInsurance([]);
        setPaidInsurance([]);
      }
    };

    loadExtras();
  }, [languageId]);

  // ==========================================================
  // INITIALIZE FREE EXTRAS
  // ==========================================================

  useEffect(() => {
    const quantities = {};
    const checked = {};

    freeExtras.forEach((item) => {
      const id = Number(item.optdet_id ?? item.optitem_id);

      if (!id) {
        return;
      }

      quantities[id] = 1;
      checked[id] = false;
    });

    setSelectedFreeExtras(quantities);

    setFreeExtraChecked(checked);
  }, [freeExtras]);

  // ==========================================================
  // INITIALIZE PAID EXTRAS
  // ==========================================================

  useEffect(() => {
    const quantities = {};
    const checked = {};

    paidExtras.forEach((item) => {
      const id = Number(item.optdet_id ?? item.optitem_id);

      if (!id) {
        return;
      }

      quantities[id] = 1;
      checked[id] = false;
    });

    setSelectedPaidExtras(quantities);

    setPaidExtraChecked(checked);
  }, [paidExtras]);

  // ==========================================================
  // INITIALIZE FREE INSURANCE
  // ==========================================================
  // Free insurance has no price impact, so it's fine (and expected)
  // for these to default to "included" / checked.

  useEffect(() => {
    const checked = {};

    freeInsurance.forEach((item) => {
      const id = Number(item.insitem_id);

      if (!id) {
        return;
      }

      checked[id] = true;
    });

    setFreeInsuranceChecked(checked);
  }, [freeInsurance]);

  // ==========================================================
  // INITIALIZE PAID INSURANCE
  // ==========================================================
  // Paid insurance MUST default to unchecked (opt-in), the same
  // way paid extras do.

  const [selectedPaidInsuranceQty] = useState({}); // reserved, insurance has no qty today

  useEffect(() => {
    const checked = {};

    paidInsurance.forEach((item) => {
      const id = Number(item.insdtl_id ?? item.insitem_id);

      if (!id) {
        return;
      }

      checked[id] = false;
    });

    setPaidInsuranceChecked(checked);
  }, [paidInsurance]);

  // ==========================================================
  // CAR IMAGE
  // ==========================================================

  const getCarImage = (image) => {
    if (!image) {
      return "";
    }

    let imagePath = String(image).trim();

    if (!imagePath) {
      return "";
    }

    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
      return imagePath;
    }

    imagePath = imagePath.replace(/^\/+/, "");

    const imageBase = IMAGE_BASE_URL || "http://localhost:5555/uploads";

    if (imagePath.startsWith("images/")) {
      return `${imageBase}/${imagePath}`;
    }

    if (imagePath.startsWith("CarImage/")) {
      return `${imageBase}/images/${imagePath}`;
    }

    return `${imageBase}/images/CarImage/${imagePath}`;
  };

  // ==========================================================
  //  Extra details /  Optional Extras  // 1416
  // ==========================================================

  const getExtradetails = (image) => {
    if (!image) {
      return "";
    }

    let imagePath = String(image).trim();

    if (!imagePath) {
      return "";
    }

    if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
      return imagePath;
    }

    imagePath = imagePath.replace(/^\/+/, "");

    const imageBase = "https://creteadmin.oriesolutions.co.in";

    return `${imageBase}/images/${imagePath}`;
  };

  // ==========================================================
  // DATE / TIME
  // ==========================================================

  const formatDate = (date) => {
    if (!date) {
      return "";
    }

    return String(date);
  };

  const getTime = (hour, minute) => {
    if (hour === undefined || hour === null || hour === "") {
      return "";
    }

    return `${hour}:${String(minute ?? "00").padStart(2, "0")}`;
  };

  // ==========================================================
  // RENTAL DAYS
  // ==========================================================

  const rentalDays = useMemo(() => {
    if (!bookingCriteria) {
      return 1;
    }

    const pickup = bookingCriteria.pickdate || bookingCriteria.pickDate;

    const drop = bookingCriteria.returndate || bookingCriteria.returnDate;

    if (!pickup || !drop) {
      return 1;
    }

    const parseDate = (value) => {
      if (value instanceof Date) {
        return value;
      }

      const stringValue = String(value);

      const parts = stringValue.split("/");

      if (parts.length === 3) {
        const day = Number(parts[0]);

        const month = Number(parts[1]) - 1;

        const year = Number(parts[2]);

        return new Date(year, month, day);
      }

      return new Date(stringValue);
    };

    const pickupDate = parseDate(pickup);

    const returnDate = parseDate(drop);

    if (
      Number.isNaN(pickupDate.getTime()) ||
      Number.isNaN(returnDate.getTime())
    ) {
      return 1;
    }

    const difference = returnDate.getTime() - pickupDate.getTime();

    const days = Math.ceil(difference / (1000 * 60 * 60 * 24));

    return Math.max(1, days);
  }, [bookingCriteria]);

  // ==========================================================
  // CAR DETAILS
  // ==========================================================

  const carName =
    translatedCar?.name ||
    translatedCar?.car_name ||
    translatedCar?.carmodel_name ||
    car?.carmodel_name ||
    car?.name ||
    car?.carmodel ||
    bt("selectedCar", "Selected car");

  const category =
    translatedCar?.category ||
    translatedCar?.car_category ||
    translatedCar?.cat_name ||
    car?.cat_name ||
    car?.category ||
    "";

  const carImage = getCarImage(car?.carmodel_image || car?.image);

  const passengers = car?.carmodel_passgrno ?? car?.passengers ?? 0;

  const luggage = car?.carmodel_luggno ?? car?.luggage ?? 0;

  const transmission = car?.transmission || car?.gear || bt("manual", "Manual");

  const airCondition =
    car?.carmodel_airconditionr || car?.carmodel_airconditionr || "Air-Co";
  const doors = car?.doors || car?.carmodel_doors || "4";

  // ==========================================================
  // PRICE
  // ==========================================================

  const pricePerDay = Number(
    car?.pricePerDay ?? car?.price_perday ?? car?.price ?? 0
  );

  const storedFinalPrice = Number(car?.finalPrice ?? car?.final_price ?? 0);

  const rentalPrice =
    storedFinalPrice > 0 ? storedFinalPrice : pricePerDay * rentalDays;

  // ==========================================================
  // LOCATION CHARGES
  // ==========================================================

  // CODE-1416
  const pickupLocation = locations.find(
    (loc) => String(loc.loc_id) === String(bookingCriteria?.cmbPickLocation)
  );
  // CODE-1416
  const dropoffLocation = locations.find(
    (loc) => String(loc.loc_id) === String(bookingCriteria?.cmbDropLocation)
  );
  // CODE-1416
  const pickupCharge = Number(pickupLocation?.loc_pickupprice ?? 20);
  // CODE-1416
  const dropoffCharge = Number(dropoffLocation?.loc_dropupprice || 15);

  const oneWayCharge = Number(
    bookingCriteria?.oneWayCharge ?? bookingCriteria?.one_way_charge ?? 25
  );

  // ==========================================================
  // RENTAL TOTAL BEFORE EXTRAS
  // ==========================================================

  const rentalTotal = rentalPrice + pickupCharge + dropoffCharge + oneWayCharge;

  // ==========================================================
  // FREE EXTRA HANDLERS
  // ==========================================================

  const updateFreeExtra = (id, value) => {
    const quantity = Number(value);

    setSelectedFreeExtras((previous) => ({
      ...previous,
      [id]: quantity >= 1 ? quantity : 1,
    }));
  };

  const toggleFreeExtra = (id) => {
    setFreeExtraChecked((previous) => ({
      ...previous,
      [id]: !previous[id],
    }));
  };

  // ==========================================================
  // PAID EXTRA HANDLERS
  // ==========================================================

  const togglePaidExtra = (id) => {
    setPaidExtraChecked((previous) => ({
      ...previous,
      [id]: !previous[id],
    }));
  };

  const updatePaidExtra = (id, value) => {
    const quantity = Number(value);

    setSelectedPaidExtras((previous) => ({
      ...previous,
      [id]: quantity >= 1 ? quantity : 1,
    }));
  };

  // ==========================================================
  // INSURANCE HANDLERS
  // ==========================================================

  const toggleFreeInsurance = (id) => {
    setFreeInsuranceChecked((previous) => ({
      ...previous,
      [id]: !previous[id],
    }));
  };

  const togglePaidInsurance = (id) => {
    setPaidInsuranceChecked((previous) => ({
      ...previous,
      [id]: !previous[id],
    }));
  };

  // ==========================================================
  // PAID EXTRA CALCULATION
  // ==========================================================

  const getPaidExtraBaseTotal = (item) => {
    const dayRate = Number(
      item.dayRate ?? item.day_rate ?? item.ratePerDay ?? item.rate_per_day ?? 0
    );

    let ratePaid = dayRate * rentalDays;

    const maxRate = Number(item.maxRate ?? item.max_rate ?? 0);

    if (maxRate > 0 && ratePaid > maxRate) {
      ratePaid = maxRate;
    }

    return ratePaid;
  };

  // ==========================================================
  // PAID INSURANCE CALCULATION (per-day rate, capped like extras
  // if a max is provided by the API)
  // ==========================================================

  const getPaidInsuranceBaseTotal = (item) => {
    const dayRate = Number(item.chargePerDay ?? item.charge_per_day ?? 0);

    let total = dayRate * rentalDays;

    const maxRate = Number(item.maxRate ?? item.max_rate ?? 0);

    if (maxRate > 0 && total > maxRate) {
      total = maxRate;
    }

    return total;
  };

  // ==========================================================
  // PAID EXTRAS TOTAL
  // ==========================================================

  const paidExtrasTotal = paidExtras.reduce((total, item) => {
    const id = Number(item.optdet_id ?? item.optitem_id);

    const checked = paidExtraChecked[id] === true;

    if (!checked) {
      return total;
    }

    const quantity = Number(selectedPaidExtras[id] || 1);

    const baseTotal = getPaidExtraBaseTotal(item);

    return total + baseTotal * quantity;
  }, 0);

  // ==========================================================
  // PAID INSURANCE TOTAL
  // ==========================================================
  // Only items the customer has explicitly checked are included.

  const paidInsuranceTotal = paidInsurance.reduce((total, item) => {
    const id = Number(item.insdtl_id ?? item.insitem_id);

    const checked = paidInsuranceChecked[id] === true;

    if (!checked) {
      return total;
    }

    const amount = getPaidInsuranceBaseTotal(item);

    return total + amount;
  }, 0);

  // ==========================================================
  // TOTAL EXTRA CHARGES
  // ==========================================================

  const totalExtraCharges = paidExtrasTotal + paidInsuranceTotal;

  // ==========================================================
  // TOTAL BEFORE COUPON
  // ==========================================================

  const totalBeforeCoupon = rentalTotal + totalExtraCharges;

  // ==========================================================
  // COUPON DISCOUNT
  // ==========================================================

  const couponDiscountAmount = Math.min(
    Math.max(Number(couponDiscount || 0), 0),
    totalBeforeCoupon
  );

  // ==========================================================
  // FINAL TOTAL
  // ==========================================================

  const finalTotal = Math.max(0, totalBeforeCoupon - couponDiscountAmount);

  // ==========================================================
  // OPEN TERMS
  // ==========================================================

  const openTerms = (e) => {
    if (e) {
      e.preventDefault();
    }

    setShowTermsModal(true);
  };

  // ==========================================================
  // CLOSE TERMS
  // ==========================================================

  const closeTerms = () => {
    setShowTermsModal(false);
  };

  // ==========================================================
  // APPLY COUPON
  // ==========================================================

  const handleApplyCoupon = async () => {
    const code = couponCode.trim();

    if (!code) {
      setCouponError("Please enter coupon code.");

      return;
    }

    const selectedModelId =
      car?.selectedmodelid || car?.carmodel_id || car?.carmodelId || car?.id;

    if (!selectedModelId) {
      setCouponError("Car model not found.");

      return;
    }

    if (!bookingCriteria) {
      setCouponError("Booking information not found.");

      return;
    }

    const estimatedTotal = Number(totalBeforeCoupon || 0);

    if (estimatedTotal <= 0) {
      setCouponError("Invalid total amount.");

      return;
    }

    try {
      setCouponLoading(true);
      setCouponMessage("");
      setCouponError("");

      const response = await api.post("/coupons/validate", {
        coupon: code,
        selectedmodelid: selectedModelId,
        pickdate: bookingCriteria.pickdate,
        returndate: bookingCriteria.returndate,
        estimatedTotal: estimatedTotal,
      });

      console.log("COUPON API RESPONSE:", response.data);

      const data = response.data || {};

      // ====================================================
      // VALID COUPON
      // ====================================================

      if (data.isvalid === "1" || data.isvalid === 1 || data.valid === true) {
        const discountPercentage = Number(data.discount || 0);

        /*
         * PHP logic:
         *
         * percentInDecimal = discount / 100
         * percent = percentInDecimal * Estimatedtotal
         *
         * We reproduce the same calculation here.
         */

        const calculatedDiscount = (estimatedTotal * discountPercentage) / 100;

        const discountAmount = Math.min(
          Math.max(calculatedDiscount, 0),
          estimatedTotal
        );

        const returnedNewPrice = Number(data.newprice || 0);

        const newPrice =
          returnedNewPrice > 0
            ? returnedNewPrice
            : estimatedTotal - discountAmount;

        // ==================================================
        // SAVE COUPON
        // ==================================================

        setCouponDiscount(discountAmount);

        setCouponDiscountPercentage(discountPercentage);

        setAppliedCoupon({
          code: data.code_name || code,

          code_name: data.code_name || code,

          discountType: "percentage",

          discountValue: discountPercentage,

          discount: discountPercentage,

          discountAmount: discountAmount,

          newprice: newPrice,
        });

        setCouponMessage(
          `Coupon "${data.code_name || code}" ${t(
            "othersnewstatics.othersnewstatic57",
            "applied successfully"
          )}?`
        );

        setCouponError("");
      }

      // ====================================================
      // INVALID COUPON
      // ====================================================
      else {
        setCouponDiscount(0);

        setCouponDiscountPercentage(0);

        setAppliedCoupon(null);

        setCouponMessage("");

        setCouponError(data.message || "Invalid Coupon Code!!");
      }
    } catch (error) {
      console.error("COUPON VALIDATION ERROR:", error);

      console.error("COUPON ERROR RESPONSE:", error.response?.data);

      setCouponDiscount(0);

      setCouponDiscountPercentage(0);

      setAppliedCoupon(null);

      setCouponMessage("");

      setCouponError(
        error.response?.data?.message || "Unable to validate coupon."
      );
    } finally {
      setCouponLoading(false);
    }
  };

  // ==========================================================
  // REMOVE COUPON
  // ==========================================================

  const handleRemoveCoupon = () => {
    setCouponCode("");

    setCouponDiscount(0);

    setCouponDiscountPercentage(0);

    setAppliedCoupon(null);

    setCouponMessage("");

    setCouponError("");
  };

  // ==========================================================
  // CONFIRM BOOKING
  // ==========================================================

  const handleConfirmBooking = async () => {
    if (submitting) {
      return;
    }

    // ------------------------------------------------------
    // FIRST NAME
    // ------------------------------------------------------

    if (!customer.firstName.trim()) {
      alert(`${pt("personaldtls2", "First name")} is required.`);

      return;
    }

    // ------------------------------------------------------
    // LAST NAME
    // ------------------------------------------------------

    if (!customer.lastName.trim()) {
      alert(`${pt("personaldtls3", "Family name")} is required.`);

      return;
    }

    // ------------------------------------------------------
    // EMAIL
    // ------------------------------------------------------

    if (!customer.email.trim()) {
      alert(`${pt("personaldtls4", "Email ID")} is required.`);

      return;
    }

    // ------------------------------------------------------
    // EMAIL FORMAT
    // ------------------------------------------------------

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(customer.email.trim())) {
      alert("Please enter a valid email address.");

      return;
    }

    // ------------------------------------------------------
    // CONFIRM EMAIL
    // ------------------------------------------------------

    if (!customer.confirmEmail.trim()) {
      alert(`${pt("personaldtls5", "Confirm Email ID")} is required.`);

      return;
    }

    // ------------------------------------------------------
    // EMAIL MATCH
    // ------------------------------------------------------

    if (customer.email.trim() !== customer.confirmEmail.trim()) {
      alert("Email ID and Confirm Email ID do not match.");

      return;
    }

    // ------------------------------------------------------
    // PHONE
    // ------------------------------------------------------

    if (!customer.phone.trim() && !customer.mobile.trim()) {
      alert(pt("personaldtls6", "Please provide at least one mobile number"));

      return;
    }

    // ------------------------------------------------------
    // TERMS
    // ------------------------------------------------------

    if (!acceptedTerms) {
      alert(
        bt("acceptTermsRequired", "Please accept the terms and conditions.")
      );

      return;
    }

    // ======================================================
    // ACTIVE FREE EXTRAS
    // ======================================================

    const activeFreeExtras = {};

    freeExtras.forEach((item) => {
      const id = Number(item.optdet_id ?? item.optitem_id);

      if (freeExtraChecked[id]) {
        activeFreeExtras[id] = Number(selectedFreeExtras[id] || 1);
      }
    });

    // ======================================================
    // ACTIVE PAID EXTRAS
    // ======================================================

    const activePaidExtras = {};

    paidExtras.forEach((item) => {
      const id = Number(item.optdet_id ?? item.optitem_id);

      if (paidExtraChecked[id]) {
        activePaidExtras[id] = Number(selectedPaidExtras[id] || 1);
      }
    });

    // ======================================================
    // ACTIVE FREE INSURANCE
    // ======================================================

    const activeFreeInsurance = [];

    freeInsurance.forEach((item) => {
      const id = Number(item.insitem_id);

      if (freeInsuranceChecked[id]) {
        activeFreeInsurance.push(id);
      }
    });

    // ======================================================
    // ACTIVE PAID INSURANCE
    // ======================================================

    const activePaidInsurance = [];

    paidInsurance.forEach((item) => {
      const id = Number(item.insdtl_id ?? item.insitem_id);

      if (paidInsuranceChecked[id]) {
        activePaidInsurance.push(id);
      }
    });

    // ======================================================
    // BOOKING DATA
    // ======================================================

    const bookingData = {
      car,

      bookingCriteria,

      rentalDays,

      rentalPrice,

      pickupCharge,

      dropoffCharge,

      oneWayCharge,

      rentalTotal,

      freeExtras: activeFreeExtras,

      paidExtras: activePaidExtras,

      freeExtraSelection: selectedFreeExtras,

      paidExtraSelection: selectedPaidExtras,

      freeExtraChecked,

      paidExtraChecked,

      freeInsurance: activeFreeInsurance,

      paidInsurance: activePaidInsurance,

      freeInsuranceChecked,

      paidInsuranceChecked,

      paidExtrasTotal,

      paidInsuranceTotal,

      totalExtraCharges,

      // ================================================
      // COUPON
      // ================================================

      couponCode: appliedCoupon?.code || "",

      couponDiscount: couponDiscountAmount,

      couponDiscountPercentage: couponDiscountPercentage,

      appliedCoupon,

      totalBeforeCoupon,

      finalTotal,
    };

    // ======================================================
    // CREATE BOOKING
    // ======================================================

    try {
      setSubmitting(true);

      const couponType = appliedCoupon?.discountType || "";

      const couponValue = Number(appliedCoupon?.discountValue || 0);

      /*
       * Existing PHP convention:
       *
       * 0 = no discount
       * 1 = percentage
       * 2 = fixed amount
       */

      const discountTypeValue = appliedCoupon
        ? couponType === "percentage"
          ? 1
          : 2
        : 0;

      // Coupon values saved to tbl_onlinebooking
      const couponCodeToSave = appliedCoupon?.code || "";
      const couponPercentToSave = couponType === "percentage" ? couponValue : 0;
      const couponAmountToSave = Number(couponDiscountAmount.toFixed(2));

      // ====================================================
      // PAYLOAD
      // ====================================================

      const payload = {
        // ==================================================
        // CUSTOMER
        // ==================================================

        online_title: customer.title,

        online_firstname: customer.firstName,

        online_lastname: customer.lastName,

        online_telephone: customer.phone,

        online_mobileno: customer.mobile || customer.phone,

        online_gender: "",

        online_emailid: customer.email,

        online_postcode: customer.postcode,

        online_city: customer.city,

        online_country: customer.country,

        online_address: customer.address,

        // ==================================================
        // COMMENTS
        // ==================================================

        online_remarks: customer.remarks,

        online_dropoffremarks: customer.dropoffRemarks,

        // ==================================================
        // LOCATIONS
        // ==================================================

        online_pickdetails: getLocationName(bookingCriteria?.cmbPickLocation),

        online_dropdetails: getLocationName(bookingCriteria?.cmbDropLocation),

        online_pickcity: getLocationName(bookingCriteria?.cmbPickLocation),

        online_returncity: getLocationName(bookingCriteria?.cmbDropLocation),

        online_pickstation: bookingCriteria?.cmbPickLocation || "",

        online_returnstation: bookingCriteria?.cmbDropLocation || "",

        // ==================================================
        // DATES
        // ==================================================

        online_pickdate: bookingCriteria?.pickdate || "",

        online_returndate: bookingCriteria?.returndate || "",

        online_picktime: getTime(
          bookingCriteria?.cmbpickHour,
          bookingCriteria?.cmbpickmin
        ),

        online_returntime: getTime(
          bookingCriteria?.cmbreturnHour,
          bookingCriteria?.cmbreturnmin
        ),

        online_diffdate: rentalDays,

        online_diffhour: 0,

        // ==================================================
        // CAR
        // ==================================================

        online_carmodelid:
          car?.selectedmodelid ||
          car?.carmodel_id ||
          car?.car_id ||
          car?.id ||
          0,

        online_carcatid: car?.selectedcatid || car?.cat_id || 0,

        // ==================================================
        // PRICE
        // ==================================================

        online_carprice: rentalPrice,

        online_offlineprice: rentalPrice,

        online_onlineprice: finalTotal,

        // ==================================================
        // LOCATION CHARGES
        // ==================================================

        online_pickhourcharge: 0,

        online_drophourcharge: 0,

        online_locpickupcharge: pickupCharge,

        online_locdropoffcharge: dropoffCharge,

        online_picknightcharge: 0,

        online_dropnightcharge: 0,

        online_extrahrcharge: 0,

        // ==================================================
        // EXTRAS / INSURANCE
        // ==================================================

        online_totaloptextras: paidExtrasTotal,

        online_totalinsurance: paidInsuranceTotal,

        online_onewayrentalcharges: oneWayCharge,

        // ==================================================
        // DRIVER
        // ==================================================

        online_driverage: bookingCriteria?.cmbdrvage || 0,

        // ==================================================
        // COUPON
        // Same values are sent under the old names and under the
        // exact database column names, so the backend can use either.
        // ==================================================

        coupon_code: couponCodeToSave,

        coupon_discount: couponAmountToSave,

        online_discpercent: couponPercentToSave,

        online_disctype: discountTypeValue,

        online_discamount: couponAmountToSave,

        // Database column names: tbl_onlinebooking
        Coupon_Code: couponCodeToSave,

        Coup_DiscountPerc: couponPercentToSave,

        Coup_DiscountAmt: couponAmountToSave,

        // ==================================================
        // LANGUAGE / PAYMENT
        // ==================================================

        online_lang: languageId,

        payment_type: paymentMethod === "paynow" ? 1 : 0,

        freeExtras: activeFreeExtras, // { [optdet_id]: qty }
        paidExtras: activePaidExtras, // { [optdet_id]: qty }
        freeInsurance: activeFreeInsurance, // [insitem_id, ...]
        paidInsurance: activePaidInsurance, // [insdtl_id, ...]

        booked_through: 1,

        // REGULAR CLIENT
        online_clientid:
          regularClient?.clientid || bookingCriteria?.clientid || "",
        online_clientemail:
          regularClient?.clientemail || bookingCriteria?.clientemail || "",
      };

      console.log("COUPON SENT:", {
        Coupon_Code: payload.Coupon_Code,
        Coup_DiscountPerc: payload.Coup_DiscountPerc,
        Coup_DiscountAmt: payload.Coup_DiscountAmt,
      });

      console.log("BOOKING PAYLOAD:", payload);

      // ====================================================
      // CREATE BOOKING
      // ====================================================

      const response = await api.post("/bookings/create", payload);

      const result = response.data;

      console.log("CREATE BOOKING RESPONSE:", result);

      // ====================================================
      // CHECK RESPONSE
      // ====================================================

      if (!result || !result.success) {
        alert(
          result?.message ||
            bt("bookingCreateFailed", "Unable to create booking.")
        );

        return;
      }

      // ====================================================
      // FINAL BOOKING
      // ====================================================

      const finalBooking = {
        bookingData,

        customer,

        paymentMethod,

        acceptedTerms,

        couponCode: appliedCoupon?.code || "",

        couponDiscount: couponDiscountAmount,

        couponDiscountPercentage: couponDiscountPercentage,

        appliedCoupon,

        confirmedAt: new Date().toISOString(),

        bookingid: result.bookingid,

        fullbooking_no: result.fullbooking_no,
      };

      // ====================================================
      // SAVE FINAL BOOKING
      // ====================================================

      sessionStorage.setItem("finalBooking", JSON.stringify(finalBooking));

      sessionStorage.setItem("bookingStepThree", JSON.stringify(bookingData));

      // ====================================================
      // NAVIGATE
      // ====================================================

      navigate("/confirmbooking", {
        state: {
          bookingid: result.bookingid,
        },
      });
    } catch (error) {
      console.error("CREATE BOOKING ERROR:", error);

      console.error("Response Data:", error.response?.data);

      alert(
        error.response?.data?.message ||
          bt("bookingServerError", "Server error while creating booking.")
      );
    } finally {
      setSubmitting(false);
    }
  };

  // ==========================================================
  // PREVIOUS
  // ==========================================================

  const handlePrevious = () => {
    navigate("/bookacar");
  };

  // ==========================================================
  // MODIFY BOOKING - OPEN FORM
  // ==========================================================

  const handleOpenModify = () => {
    if (showModifyForm) {
      setShowModifyForm(false);
      return;
    }

    setModifyForm({
      ...(bookingCriteria || {}),
    });

    setShowModifyForm(true);
  };

  // ==========================================================
  // MODIFY BOOKING - FIELD CHANGE
  // ==========================================================

  const handleModifyChange = (field, value) => {
    setModifyForm((previous) => ({
      ...(previous || {}),
      [field]: value,
    }));
  };

  // ==========================================================
  // MODIFY BOOKING - SUBMIT
  // ==========================================================

  const handleModifySubmit = (e) => {
    e.preventDefault();

    if (!modifyForm) {
      return;
    }

    if (
      !modifyForm.cmbPickLocation ||
      !modifyForm.pickdate ||
      !modifyForm.cmbDropLocation ||
      !modifyForm.returndate
    ) {
      alert(
        bt(
          "completeBookingDetails",
          "Please complete pickup and return details."
        )
      );
      return;
    }

    const pickupHour = modifyForm.cmbpickHour || "10";
    const pickupMinute = modifyForm.cmbpickmin || "00";
    const returnHour = modifyForm.cmbreturnHour || "10";
    const returnMinute = modifyForm.cmbreturnmin || "00";

    const pickupDateTime = new Date(
      `${modifyForm.pickdate}T${pickupHour}:${pickupMinute}:00`
    );

    const returnDateTime = new Date(
      `${modifyForm.returndate}T${returnHour}:${returnMinute}:00`
    );

    if (returnDateTime <= pickupDateTime) {
      alert(
        bt(
          "returnDateAfterPickup",
          "Return date/time must be after pickup date/time."
        )
      );
      return;
    }

    const updatedCriteria = {
      ...modifyForm,
      cmbpickHour: pickupHour,
      cmbpickmin: pickupMinute,
      cmbreturnHour: returnHour,
      cmbreturnmin: returnMinute,
    };

    sessionStorage.setItem("bookingCriteria", JSON.stringify(updatedCriteria));

    setBookingCriteria(updatedCriteria);
    setModifyForm({ ...updatedCriteria });
    setShowModifyForm(false);

    // Go back to the car search page so the modified
    // dates/times are used to calculate fresh car prices.
    navigate("/bookacar");
  };

  // ==========================================================
  // LOADING
  // ==========================================================

  if (loading) {
    return (
      <div
        className="text-center"
        style={{
          padding: "100px 20px",
        }}
      >
        <h4>{bt("loadingBookingDetails", "Loading booking details...")}</h4>
      </div>
    );
  }

  if (!car) {
    return null;
  }

  // ==========================================================
  // UI
  // ==========================================================

  return (
    <div className="p20">
      {submitting && ( // 1416
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100vh",
            background: "rgba(247, 247, 247, 0.71)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <img
            src={loderImage}
            alt="Loading..."
            style={{
              objectFit: "contain",
              opacity: 0.6,
              background: "transparent",
            }}
          />
        </div>
      )}
      <div className="p0 container container2 p0">
        {/* ==================================================
            SIDEBAR
        ================================================== */}

        <div
          className="col-md-3 sidebar"
          style={{
            float: "left",
          }}
        >
          <div className="booking-wrapper">
            {/* BOOKING SUMMARY */}

            <div className="booking-card">
              <div className="card-header">
                <h3>{t("others.others32", "Modify Your Search")}</h3>

                <button
                  type="button"
                  className="search-btn"
                  onClick={handleOpenModify}
                  aria-expanded={showModifyForm}
                >
                  {t("modify.modify0", "MODIFY")}{" "}
                  <img
                    src={darrow}
                    alt=""
                    style={{
                      width: "13px",
                      height: "13px",
                      objectFit: "contain",
                      marginLeft: "5px",
                      verticalAlign: "middle",
                    }}
                  />
                </button>
              </div>

              {/* PICKUP / RETURN BOOKING SUMMARY */}
              <div className="booking-summary-details">
                {/* PICKUP */}
                <div className="booking-item">
                  <div className="icon-area">
                    <img
                      src={lmap}
                      alt=""
                      style={{
                        width: "20px",
                        height: "20px",
                        objectFit: "contain",
                      }}
                    />

                    <div className="line"></div>
                  </div>

                  <div className="booking-content">
                    <h4>{getLocationName(bookingCriteria?.cmbPickLocation)}</h4>

                    <p>
                      {formatDate(bookingCriteria?.pickdate)}
                      {" @ "}
                      {getTime(
                        bookingCriteria?.cmbpickHour,
                        bookingCriteria?.cmbpickmin
                      )}
                    </p>
                  </div>
                </div>

                {/* RETURN */}
                <div className="booking-item">
                  <div className="icon-area">
                    <img
                      src={lmap}
                      alt=""
                      style={{
                        width: "20px",
                        height: "20px",
                        objectFit: "contain",
                      }}
                    />
                  </div>

                  <div className="booking-content">
                    <h4>{getLocationName(bookingCriteria?.cmbDropLocation)}</h4>

                    <p>
                      {formatDate(bookingCriteria?.returndate)}
                      {" @ "}
                      {getTime(
                        bookingCriteria?.cmbreturnHour,
                        bookingCriteria?.cmbreturnmin
                      )}
                    </p>
                  </div>
                </div>
              </div>

              {/* MODIFY FORM - OPEN BELOW THE BOOKING SUMMARY */}
              {showModifyForm && (
                <div
                  className="modify-form-container"
                  style={{
                    borderTop: "1px solid #ddd",
                    marginTop: "8px",
                    paddingTop: "8px",
                  }}
                >
                  <form onSubmit={handleModifySubmit}>
                    {/* PICKUP INFORMATION */}
                    <div
                      className="col-md-12"
                      style={{
                        float: "left",
                      }}
                    >
                      <label className="label" style={{ marginBottom: "0" }}>
                        <strong>
                          {t(
                            "bookingengine.bookingengine0",
                            "Pick-up Location"
                          )}
                        </strong>
                      </label>

                      {/* PICKUP LOCATION */}
                      <div
                        className="col-lg-12 form-group"
                        style={{ padding: "4px 0" }}
                      >
                        <select
                          className="arrow  form-control select"
                          value={modifyForm?.cmbPickLocation || ""}
                          onChange={(e) =>
                            handleModifyChange(
                              "cmbPickLocation",
                              e.target.value
                            )
                          }
                        >
                          <option value="">
                            {t(
                              "bookingengine.bookingengine8",
                              "Select location"
                            )}
                          </option>

                          {locations.map((loc) => (
                            <option key={loc.loc_id} value={loc.loc_id}>
                              {loc.loc_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* PICKUP DATE */}
                      <div
                        className="col-lg-12 form-group"
                        style={{ padding: "4px 0" }}
                      >
                        <label className="label">
                          <strong>
                            {t(
                              "bookingengine.bookingengine1",
                              "Pick-up Date & Time"
                            )}
                          </strong>
                        </label>
                        <input
                          type="date"
                          className=" form-control"
                          value={modifyForm?.pickdate || ""}
                          onChange={(e) =>
                            handleModifyChange("pickdate", e.target.value)
                          }
                        />
                      </div>

                      {/* PICKUP TIME */}
                      <div
                        className="col-lg-12 form-group"
                        style={{ padding: "4px 0" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "3px",
                          }}
                        >
                          <select
                            className="arrow form-control"
                            value={modifyForm?.cmbpickHour || "10"}
                            onChange={(e) =>
                              handleModifyChange("cmbpickHour", e.target.value)
                            }
                          >
                            {Array.from({ length: 24 }, (_, index) =>
                              String(index).padStart(2, "0")
                            ).map((hour) => (
                              <option key={hour} value={hour}>
                                {hour}
                              </option>
                            ))}
                          </select>

                          <select
                            className="arrow form-control"
                            value={modifyForm?.cmbpickmin || "00"}
                            onChange={(e) =>
                              handleModifyChange("cmbpickmin", e.target.value)
                            }
                          >
                            {Array.from({ length: 12 }, (_, index) =>
                              String(index * 5).padStart(2, "0")
                            ).map((minute) => (
                              <option key={minute} value={minute}>
                                {minute}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* RETURN INFORMATION */}
                    <div
                      className="col-md-12"
                      style={{
                        float: "left",
                      }}
                    >
                      <label className="label" style={{ marginBottom: "0" }}>
                        <strong>
                          {t(
                            "bookingengine.bookingengine3",
                            "Drop-off Location"
                          )}
                        </strong>
                      </label>

                      {/* RETURN LOCATION */}
                      <div
                        className="col-lg-12 form-group"
                        style={{ padding: "4px 0" }}
                      >
                        <select
                          className="arrow form-control select"
                          value={modifyForm?.cmbDropLocation || ""}
                          onChange={(e) =>
                            handleModifyChange(
                              "cmbDropLocation",
                              e.target.value
                            )
                          }
                        >
                          <option value="">
                            {t(
                              "bookingengine.bookingengine8",
                              "Select location"
                            )}
                          </option>

                          {locations.map((loc) => (
                            <option key={loc.loc_id} value={loc.loc_id}>
                              {loc.loc_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* RETURN DATE */}
                      <div
                        className="col-lg-12 form-group"
                        style={{ padding: "4px 0" }}
                      >
                        <label className="label">
                          <strong>
                            {t(
                              "bookingengine.bookingengine3",
                              "Drop-off Date & Time"
                            )}
                          </strong>
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          value={modifyForm?.returndate || ""}
                          onChange={(e) =>
                            handleModifyChange("returndate", e.target.value)
                          }
                        />
                      </div>

                      {/* RETURN TIME */}
                      <div
                        className="col-lg-12 form-group"
                        style={{ padding: "4px 0" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "3px",
                          }}
                        >
                          <select
                            className="arrow form-control"
                            value={modifyForm?.cmbreturnHour || "10"}
                            onChange={(e) =>
                              handleModifyChange(
                                "cmbreturnHour",
                                e.target.value
                              )
                            }
                          >
                            {Array.from({ length: 24 }, (_, index) =>
                              String(index).padStart(2, "0")
                            ).map((hour) => (
                              <option key={hour} value={hour}>
                                {hour}
                              </option>
                            ))}
                          </select>

                          <select
                            className="arrow form-control"
                            value={modifyForm?.cmbreturnmin || "00"}
                            onChange={(e) =>
                              handleModifyChange("cmbreturnmin", e.target.value)
                            }
                          >
                            {Array.from({ length: 12 }, (_, index) =>
                              String(index * 5).padStart(2, "0")
                            ).map((minute) => (
                              <option key={minute} value={minute}>
                                {minute}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    {/* CONTINUE */}
                    <div
                      className="col-md-12"
                      style={{
                        padding: 0,
                        float: "left",
                        marginTop: "8px",
                      }}
                    >
                      <button
                        type="submit"
                        className="btn btn-secondary1"
                        style={{
                          padding: "8px 0",
                          width: "100%",
                          border: "none",
                        }}
                      >
                        {t("bookingengine.bookingengine9", "Continue")}
                      </button>
                    </div>
                  </form>
                </div>
              )}
            </div>

            {/* YOUR CAR */}

            <div className="your-car">
              {t("carparams.carparams2", "Car details")}
            </div>

            <div className="car-box price-box">
              <h2
                className="car-title"
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  lineHeight: "19px",
                }}
              >
                {carName}

                <br />

                <span
                  style={{
                    fontSize: "14px",
                    fontWeight: 500,
                  }}
                >
                  {category || bt("orSimilar", "or similar")}
                </span>
              </h2>

              {carImage && (
                <img
                  src={carImage}
                  alt={carName}
                  className="car-img"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
              )}

              <div
                className="specs-row"
                style={{
                  textAlign: "center",
                  margin: "0 14px",
                }}
              >
                <span className="spec-tag">👤 {passengers}</span>

                <span className="spec-tag">🧳 {luggage}</span>

                <span className="spec-tag">
                  ❄️
                  {airCondition
                    ? t("carparams.carparams7", "Yes")
                    : t("carparams.carparams8", "No")}
                </span>

                <span className="spec-tag">🚪 {doors}</span>
              </div>

              <p
                className="car-d"
                style={{
                  textAlign: "center",
                }}
              >
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/bookacar");
                  }}
                >
                  {t("othersnewstatics.othersnewstatic54", "Car Modify")}
                </a>
              </p>

              <p className="big-size-text1">
                {t("ratechart.ratechart21", "Final Price")}
              </p>

              <p className="big-size-text">€ {rentalPrice.toFixed(2)}</p>
            </div>
          </div>

          <div className="clearfix"></div>
        </div>

        {/* ==================================================
            MAIN CONTENT
        ================================================== */}

        <div
          className="col-md-9 main-content"
          style={{
            float: "left",
          }}
        >
          {/* ==================================================
              PAID OPTIONAL EXTRAS
          ================================================== */}

          <div className="optiona-extras">
            <strong>
              {t("othersnewstatics.othersnewstatic53", "Optional Extras")} :
            </strong>
            <br />
            <span>{et("extracharges3", "Optional Extras")}</span>
          </div>

          <div
            className="car-box price-box"
            style={{
              padding: 0,
            }}
          >
            <div className="optionalcon">
              <div className="extras">
                <table
                  width="100%"
                  border="0"
                  cellSpacing="2"
                  cellPadding="2"
                  className="table word-break"
                >
                  <thead>
                    <tr>
                      <td
                        className="optionalextra"
                        width="43%"
                        style={{
                          background: "#e6e1f7",
                        }}
                      >
                        {et("extracharges4", "Items")}
                      </td>

                      <td
                        className="optionalextra"
                        width="20%"
                        style={{
                          background: "#e6e1f7",
                        }}
                      >
                        {et("extracharges5", "Rate per day")}
                      </td>

                      <td
                        className="optionalextra"
                        width="17%"
                        style={{
                          background: "#e6e1f7",
                        }}
                      >
                        {et("extracharges6", "Total")}
                      </td>

                      <td
                        className="optionalextra"
                        width="13%"
                        align="center"
                        style={{
                          background: "#e6e1f7",
                        }}
                      >
                        {et("extracharges2", "Selection")}
                      </td>

                      <td
                        className="optionalextra"
                        width="7%"
                        align="center"
                        style={{
                          background: "#e6e1f7",
                        }}
                      >
                        &nbsp;
                      </td>
                    </tr>
                  </thead>

                  <tbody>
                    {paidExtras.map((item) => {
                      const id = Number(item.optdet_id ?? item.optitem_id);
                      const paidExtrasImage = getExtradetails(item.image); // 1416

                      const quantity = Number(selectedPaidExtras[id] || 1);

                      // IMPORTANT:
                      // Only true when USER has checked the checkbox
                      const isChecked = paidExtraChecked[id] === true;

                      const itemName =
                        item.name ||
                        item.optitem_name ||
                        item.optdet_name ||
                        "";

                      const description =
                        item.description ||
                        item.optitem_description ||
                        item.optdet_description ||
                        "";

                      const dayRate = Number(
                        item.dayRate ??
                          item.day_rate ??
                          item.ratePerDay ??
                          item.rate_per_day ??
                          0
                      );

                      const baseTotal = getPaidExtraBaseTotal(item);

                      const itemTotal = baseTotal * quantity;

                      return (
                        <tr
                          key={id}
                          style={{
                            opacity: isChecked ? 1 : 0.65,
                          }}
                        >
                          {/* ITEM NAME + IMAGE */}
                          <td
                            className="bookingtbltxt"
                            style={{
                              background: "#ffffff",
                              cursor: "pointer",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                              onClick={() => {
                                setSelectedItem({
                                  id: id,
                                  name: itemName,
                                  description: description,
                                });

                                setShowModal(true);
                              }}
                            >
                              <img
                                src={paidExtrasImage || babyseat} // 1416
                                alt="Baby Seat"
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  objectFit: "contain",
                                  borderRadius: "8px",
                                }}
                                onError={(e) => {
                                  e.currentTarget.style.display = "babyseat";
                                }}
                              />

                              <div>
                                <strong>{itemName}</strong>
                              </div>
                            </div>
                          </td>

                          {/* RATE PER DAY */}
                          <td
                            className="bookingtbltxt"
                            style={{
                              background: "#ffffff",
                            }}
                          >
                            <span className="item-name">
                              {et("extracharges5", "Rate per day")} :{" "}
                            </span>
                            {dayRate.toFixed(2)} €/
                            {et("extracharges10", "Day")}
                          </td>

                          {/* TOTAL */}
                          <td
                            className="bookingtbltxt"
                            style={{
                              background: "#ffffff",
                            }}
                          >
                            <span className="item-name">
                              {et("extracharges6", "Total")} :{" "}
                            </span>

                            <div>
                              <strong
                                style={{
                                  color: isChecked ? "#8a74dd" : "#999",
                                }}
                              >
                                {itemTotal.toFixed(2)} €
                              </strong>
                            </div>
                          </td>

                          {/* QUANTITY */}
                          <td
                            className="tc"
                            align="center"
                            style={{
                              background: "#ffffff",
                            }}
                          >
                            <span className="item-name">
                              {et("extracharges2", "Selection")} :{" "}
                            </span>

                            <select
                              className="verysmallfrmtxtbox"
                              value={quantity}
                              disabled={!isChecked}
                              onChange={(e) =>
                                updatePaidExtra(id, e.target.value)
                              }
                            >
                              {Array.from(
                                {
                                  length: Math.max(1, Number(item.max || 1)),
                                },
                                (_, index) => index + 1
                              ).map((number) => (
                                <option key={number} value={number}>
                                  {number}
                                </option>
                              ))}
                            </select>
                          </td>

                          {/* CHECKBOX */}
                          <td
                            className="tc"
                            align="center"
                            style={{
                              background: "#ffffff",
                            }}
                          >
                            <input
                              className="checkbox1"
                              type="checkbox"
                              checked={isChecked}
                              onChange={() => togglePaidExtra(id)}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {showModal && selectedItem && (
            <div
              onClick={() => setShowModal(false)}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0, 0, 0, 0.45)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  width: "500px",
                  maxWidth: "90%",
                  background: "#fff",
                  borderRadius: "10px",
                  padding: "20px",
                  position: "relative",
                  boxShadow: "0 5px 25px rgba(0, 0, 0, 0.3)",
                }}
              >
                {/* Close Button */}
                <button
                  className="closebtn"
                  onClick={() => setShowModal(false)}
                >
                  ×
                </button>

                {/* Description */}
                <p
                  style={{
                    color: "#555",
                    fontSize: "14px",
                    lineHeight: "1.6",
                    margin: 0,
                    textAlign: "center",
                  }}
                >
                  {selectedItem.description || "No description available."}
                </p>
              </div>
            </div>
          )}

          <div className="smallmask"></div>

          {/* ==================================================
              FREE OPTIONAL EXTRAS
          ================================================== */}

          <div className="extra-details">
            <strong>
              {" "}
              {t("othersnewstatics.othersnewstatic52", "Extra details")}:
            </strong>
            <br />
            <span>{et("extracharges1", "Free optional extras")}</span>
          </div>

          <div
            className="car-box price-box"
            style={{
              padding: 0,
            }}
          >
            <table
              className="table word-break"
              width="100%"
              border="0"
              cellSpacing="2"
              cellPadding="2"
            >
              <thead>
                <tr>
                  <td
                    className="optionalextra"
                    style={{
                      background: "#e6e1f7",
                    }}
                  >
                    {et("extracharges4", "Items")}
                  </td>

                  <td
                    width="80"
                    align="center"
                    className="optionalextra"
                    style={{
                      background: "#e6e1f7",
                    }}
                  >
                    {et("extracharges2", "Selection")}
                  </td>

                  <td
                    width="20"
                    align="center"
                    className="extrasinftxt"
                    style={{
                      background: "#e6e1f7",
                    }}
                  >
                    &nbsp;
                  </td>
                </tr>
              </thead>

              <tbody>
                {freeExtras.map((item) => {
                  const id = Number(item.optdet_id ?? item.optitem_id);
                  const freeExtrasImage = getExtradetails(item.image); // 1416
                  const quantity = Number(selectedFreeExtras[id] || 1);

                  const checked = freeExtraChecked[id] === true;

                  const itemName =
                    item.name || item.optitem_name || item.optdet_name || "";

                  const description =
                    item.description ||
                    item.optdet_description ||
                    item.optitem_description ||
                    "";

                  return (
                    <tr
                      key={id}
                      style={{
                        opacity: checked ? 1 : 0.65,
                      }}
                    >
                      <td
                        className="bookingtbltxt"
                        style={{
                          background: "#ffffff",
                          cursor: "pointer",
                        }}
                      >
                        <span
                          onClick={() => {
                            setSelectedItem({
                              id: id,
                              name: itemName,
                              description: description,
                            });

                            setShowModal(true);
                          }}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <img
                            src={freeExtrasImage || extraIcons[id]} // 1416
                            alt={itemName}
                            style={{
                              width: "24px",
                              height: "24px",
                              objectFit: "contain",
                            }}
                          />
                          {itemName}
                        </span>
                      </td>

                      <td
                        align="center"
                        style={{
                          background: "#ffffff",
                        }}
                      >
                        <select
                          className="verysmallfrmtxtbox"
                          value={quantity}
                          disabled={!checked}
                          onChange={(e) => updateFreeExtra(id, e.target.value)}
                        >
                          {Array.from(
                            {
                              length: Math.max(1, Number(item.max || 1)),
                            },
                            (_, index) => index + 1
                          ).map((number) => (
                            <option key={number} value={number}>
                              {number}
                            </option>
                          ))}
                        </select>
                      </td>

                      <td
                        align="center"
                        style={{
                          background: "#ffffff",
                        }}
                      >
                        <input
                          className="checkbox1"
                          type="checkbox"
                          checked={checked}
                          onChange={() => toggleFreeExtra(id)}
                        />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="smallmask"></div>

          {/* ==================================================
              FREE INSURANCE
          ================================================== */}

          <div className="insurances">
            {et("extracharges9", "Free insurance")}
          </div>

          <div className="insurances-bg price-box">
            <table
              width="100%"
              border="0"
              cellSpacing="2"
              cellPadding="2"
              className="table word-break"
            >
              <thead>
                <tr>
                  <td
                    className="optionalextra"
                    style={{
                      background: "#fbebe1",
                    }}
                  >
                    {et("extracharges4", "Items")}
                  </td>
                </tr>
              </thead>

              <tbody>
                {freeInsurance.map((insurance) => {
                  const id = Number(insurance.insitem_id);

                  const checked = freeInsuranceChecked[id] === true;

                  const insuranceName = insurance.name || "";

                  // Description shown in the popup (same modal as Optional Extras)
                  const insuranceDescription =
                    insurance.description ||
                    insurance.insitem_description ||
                    insurance.insdtl_description ||
                    insurance.details ||
                    "";

                  return (
                    <tr
                      key={id}
                      style={{
                        opacity: checked ? 1 : 0.65,
                      }}
                    >
                      <td
                        className="bookingtbltxt"
                        style={{
                          background: "transparent",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                          onClick={() => {
                            setSelectedItem({
                              id: id,
                              name: insuranceName,
                              description: insuranceDescription,
                            });

                            setShowModal(true);
                          }}
                        >
                          <img
                            src={insuranceicon}
                            alt=""
                            style={{
                              marginRight: "8px",
                            }}
                            onError={(e) => {
                              e.currentTarget.style.display = "none";
                            }}
                          />

                          {insuranceName}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="smallmask"></div>

          {/* ==================================================
              PERSONAL DETAILS
          ================================================== */}

          <div className="rate">{pt("personaldtls0", "Personal details")}</div>
          {regularClient && (
            <div
              style={{ margin: "0 0 10px", fontSize: "14px", color: "#0a9311" }}
            >
              ✓ {t("menu.menu19", "Regular client")}:{" "}
              <strong>{regularClient.clientid}</strong> —
              {t(
                "othersnewstatics.othersnewstatic56",
                "your details have been filled in."
              )}
            </div>
          )}
          <div
            className="car-box price-box"
            style={{
              marginBottom: "18px",
              padding: "10px 17px",
            }}
          >
            <div className="row">
              {/* TITLE */}

              <div className="col-md-4 mb-3">
                <div className="p-line  ht">
                  {pt("personaldtls1", "Title")}{" "}
                  <span style={{ color: "#f95d2d", fontWeight: "normal" }}>
                    *
                  </span>
                </div>

                <select
                  className="verysmallfrmtxtbox"
                  name="title"
                  value={customer.title}
                  onChange={handleCustomerChange}
                >
                  <option value="Mr">{pt("personaldtls25", "Mr.")}</option>

                  <option value="Mrs">{pt("personaldtls26", "Mrs.")}</option>

                  <option value="Ms">{pt("personaldtls27", "Ms.")}</option>

                  <option value="Dr">{pt("personaldtls28", "Dr.")}</option>
                </select>
              </div>

              {/* FIRST NAME */}

              <div className="col-md-4 mb-3">
                <div className="p-line  ht">
                  {pt("personaldtls2", "First name")}{" "}
                  <span style={{ color: "#f95d2d", fontWeight: "normal" }}>
                    *
                  </span>
                </div>

                <input
                  type="text"
                  className="frmtxtbox1"
                  name="firstName"
                  value={customer.firstName}
                  onChange={handleCustomerChange}
                />
              </div>

              {/* LAST NAME */}

              <div className="col-md-4 mb-3">
                <div className="p-line  ht">
                  {pt("personaldtls3", "Family name")}{" "}
                  <span style={{ color: "#f95d2d", fontWeight: "normal" }}>
                    *
                  </span>
                </div>

                <input
                  type="text"
                  className="frmtxtbox1"
                  name="lastName"
                  value={customer.lastName}
                  onChange={handleCustomerChange}
                />
              </div>

              {/* MOBILE */}

              <div className="col-md-4 mb-3">
                <div className="p-line  ht">
                  {pt("personaldtls8", "Mobile no")}
                  <span style={{ color: "#f95d2d", fontWeight: "normal" }}>
                    *
                  </span>
                </div>

                <input
                  type="text"
                  className="frmtxtbox1"
                  name="mobile"
                  value={customer.mobile}
                  onChange={handleCustomerChange}
                />
              </div>

              {/* EMAIL */}

              <div className="col-md-4 mb-3">
                <div className="p-line  ht">
                  {pt("personaldtls4", "Email ID")}{" "}
                  <span style={{ color: "#f95d2d", fontWeight: "normal" }}>
                    *
                  </span>
                </div>

                <input
                  type="email"
                  className="frmtxtbox1"
                  name="email"
                  value={customer.email}
                  onChange={handleCustomerChange}
                />
              </div>

              {/* CONFIRM EMAIL */}

              <div className="col-md-4 mb-3">
                <div className="p-line  ht">
                  {pt("personaldtls5", "Confirm Email ID")}{" "}
                  <span style={{ color: "#f95d2d", fontWeight: "normal" }}>
                    *
                  </span>
                </div>

                <input
                  type="email"
                  className="frmtxtbox1"
                  name="confirmEmail"
                  value={customer.confirmEmail}
                  onChange={handleCustomerChange}
                />
              </div>

              {/* ADDRESS */}

              <div className="col-md-8 mb-3">
                <div className="p-line  ht">
                  {pt("personaldtls14", "Home Address")}
                  <span style={{ color: "#f95d2d", fontWeight: "normal" }}>
                    *
                  </span>
                </div>

                <textarea
                  style={{
                    width: "100%",
                    height: "160px",
                  }}
                  className="frmtxtarea"
                  name="address"
                  value={customer.address}
                  onChange={handleCustomerChange}
                />
              </div>

              {/* ZIP / CITY / COUNTRY */}

              <div className="col-md-4 mb-3">
                <div className="p-line  ht">
                  {pt("personaldtls16", "Zip code")}
                </div>

                <input
                  type="text"
                  className="frmtxtbox1"
                  name="postcode"
                  value={customer.postcode}
                  onChange={handleCustomerChange}
                />

                <div className="clearfix"></div>

                <div className="p-line  ht">
                  {pt("personaldtls15", "City")}
                  <span style={{ color: "#f95d2d", fontWeight: "normal" }}>
                    *
                  </span>
                </div>

                <input
                  type="text"
                  className="frmtxtbox1"
                  name="city"
                  value={customer.city}
                  onChange={handleCustomerChange}
                />

                <div className="clearfix"></div>

                <div className="p-line  ht">
                  {pt("personaldtls10", "Country")}
                  <span style={{ color: "#f95d2d", fontWeight: "normal" }}>
                    *
                  </span>
                </div>

                <select
                  className="frmtxtbox1"
                  name="country"
                  style={{ paddingTop: "3px" }}
                  value={customer.country}
                  onChange={handleCustomerChange}
                >
                  <option value="">Select Country</option>

                  {countries.map((country) => (
                    <option
                      key={country.country_id}
                      value={country.country_name}
                    >
                      {country.country_name}
                    </option>
                  ))}
                </select>

                <div className="clearfix"></div>
              </div>

              {/* PICK UP COMMENTS */}

              <div className="col-md-6 mb-3">
                <label className="form-label" style={{ marginBottom: "0" }}>
                  {pt("personaldtls23", "Pick up comments")}
                </label>

                <textarea
                  style={{
                    width: "100%",
                    height: "120px",
                  }}
                  className="frmtxtarea"
                  rows="3"
                  name="remarks"
                  value={customer.remarks}
                  onChange={handleCustomerChange}
                />
              </div>

              {/* DROP COMMENTS */}

              <div className="col-md-6 mb-3">
                <label className="form-label" style={{ marginBottom: "0" }}>
                  {pt("personaldtls24", "Drop off comments")}
                </label>

                <textarea
                  style={{
                    width: "100%",
                    height: "120px",
                  }}
                  className="frmtxtarea "
                  rows="3"
                  name="dropoffRemarks"
                  value={customer.dropoffRemarks}
                  onChange={handleCustomerChange}
                />
              </div>

              {/* ==================================================
                  COUPON CODE
              ================================================== */}

              <div>
                <div className="col-md-3 mb-3" style={{ float: "left" }}>
                  <div className="p-line  ht">
                    {t("others.others23", "Coupon Code")} :
                  </div>
                </div>
                <div className="col-md-3 mb-3" style={{ float: "left" }}>
                  <input
                    type="text"
                    className="frmtxtbox1"
                    value={couponCode}
                    onChange={(e) => {
                      const newCode = e.target.value.toUpperCase();

                      setCouponCode(newCode);

                      /*
                       * If coupon changes,
                       * remove old discount.
                       */

                      if (appliedCoupon) {
                        setCouponDiscount(0);

                        setCouponDiscountPercentage(0);

                        setAppliedCoupon(null);
                      }

                      setCouponError("");

                      setCouponMessage("");
                    }}
                    disabled={couponLoading}
                  />
                </div>
                <div className="col-md-2 mb-3" style={{ float: "left" }}>
                  {!appliedCoupon ? (
                    <button
                      type="button"
                      className="nextbutton rightbut"
                      onClick={handleApplyCoupon}
                      disabled={couponLoading || !couponCode.trim()}
                      style={{
                        minWidth: "100px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {couponLoading ? "Applying..." : "Apply"}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="nextbutton"
                      onClick={handleRemoveCoupon}
                      disabled={couponLoading}
                      style={{
                        minWidth: "100px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Remove
                    </button>
                  )}
                </div>
                {/* 1416 */}
                <div className="col-md-4 mb-2" style={{ float: "left" }}>
                  {couponMessage && (
                    <div
                      style={{
                        marginTop: "0px",
                        color: "#0a9311",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      ✓ {couponMessage}
                    </div>
                  )}

                  {/* ERROR */}

                  {couponError && (
                    <div
                      style={{
                        marginTop: "0px",
                        color: "#dc3545",
                        fontSize: "14px",
                        fontWeight: 500,
                      }}
                    >
                      {couponError}
                    </div>
                  )}

                  {/* APPLIED COUPON */}

                  {appliedCoupon && (
                    <div
                      style={{
                        marginTop: "0px",
                        fontSize: "14px",
                        color: "#555",
                      }}
                    >
                      {t(
                        "othersnewstatics.othersnewstatic58",
                        "Applied coupon"
                      )}{" "}
                      <strong>{appliedCoupon.code}</strong>
                      {" — "}
                      {t("others.others28", "Discount")} :{" "}
                      <strong>{couponDiscountPercentage}%</strong>
                      {" — "}
                      <strong>€ {couponDiscountAmount.toFixed(2)}</strong>
                    </div>
                  )}
                </div>
                <div className="clearfix"></div>
              </div>
            </div>

            <div className="clearfix"></div>

            {/* ==================================================
                TERMS
            ================================================== */}

            <div
              className="bookingtbltxtnew"
              style={{
                padding: "5px 24px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "10px",
                }}
              >
                <input
                  type="checkbox"
                  id="checkConfirm"
                  name="checkConfirm"
                  checked={acceptedTerms}
                  onChange={(e) => setAcceptedTerms(e.target.checked)}
                  style={{
                    marginTop: "4px",
                    width: "16px",
                    height: "16px",
                    cursor: "pointer",
                    flexShrink: 0,
                  }}
                />

                <div
                  style={{
                    lineHeight: "1.5",
                  }}
                >
                  <span>{pt("personaldtls12", "I accept the")} </span>

                  <a
                    href="#terms"
                    onClick={openTerms}
                    style={{
                      color: "#337ab7",
                      textDecoration: "underline",
                      cursor: "pointer",
                    }}
                  >
                    {termsContent?.cont_title ||
                      bt("termsConditions", "Terms & Conditions")}
                  </a>
                </div>
              </div>

              {termsLoading && (
                <div
                  style={{
                    marginTop: "8px",
                    marginLeft: "26px",
                    fontSize: "13px",
                    color: "#777",
                  }}
                >
                  {bt("loading", "Loading...")}
                </div>
              )}

              <div className="termlink">
                <span style={{ color: "red" }}>**</span>
                <strong>
                  {t(
                    "personaldtls.personaldtls19",
                    "Visitor must enter following informations in the Pick up and Drop off comments Field"
                  )}
                </strong>

                <div className="clearfix"></div>
              </div>
            </div>
          </div>

          {/* ==================================================
              RATE CHART
          ================================================== */}

          <div className="rate">{rt("ratechart4", "Rate charts")} :</div>

          <div
            className="price-box"
            style={{
              padding: 0,
            }}
          >
            <div className="rate-box">
              <div
                style={{
                  float: "left",
                  width: "100%",
                }}
              >
                <table
                  className="table word-break"
                  width="100%"
                  cellSpacing="2"
                  cellPadding="2"
                  border="0"
                  style={{
                    margin: 0,
                  }}
                >
                  <tbody>
                    <tr className="tbltxt">
                      <td width="49%">{rt("ratechart0", "Quote")}</td>

                      <td width="28%" align="center" className="tr ">
                        {rt("ratechart1", "Calculation")}
                      </td>

                      <td width="23%" align="right" className="tr ">
                        {rt("ratechart2", "Total")}
                      </td>
                    </tr>

                    <tr>
                      <td className="priceh2">
                        <strong>
                          {rt("ratechart10", "Total rental price")}
                        </strong>
                      </td>

                      <td
                        align="center"
                        className="tr priceh2"
                        style={{
                          color: "#0a9311",
                        }}
                      >
                        <strong>
                          {rentalDays} x {pricePerDay.toFixed(2)} €
                        </strong>
                      </td>

                      <td
                        align="right"
                        className="tr priceh2"
                        style={{
                          color: "#0a9311",
                        }}
                      >
                        <strong>{rentalPrice.toFixed(2)} €</strong>
                      </td>
                    </tr>

                    <tr>
                      <td colSpan="2">{rt("ratechart6", "Pick up charge")}</td>
                      <td align="right">{pickupCharge.toFixed(2)} €</td>
                    </tr>

                    <tr>
                      <td colSpan="2">{rt("ratechart3", "Drop off charge")}</td>

                      <td align="right">{dropoffCharge.toFixed(2)} €</td>
                    </tr>

                    <tr>
                      <td colSpan="2">
                        {rt("ratechart15", "One way rental charges")}
                      </td>

                      <td align="right">{oneWayCharge.toFixed(2)} €</td>
                    </tr>

                    {/* <tr>
                      <td colSpan="2" className="priceh2">
                        <strong>
                          {rt("ratechart10", "Total rental price")}
                        </strong>
                      </td>

                      <td
                        className="priceh2"
                        align="right"
                        style={{
                          color: "#8a74dd",
                        }}
                      >
                        <strong>{rentalTotal.toFixed(2)} €</strong>
                      </td>
                    </tr> */}

                    {/* ITEMIZED PAID EXTRAS */}
                    {paidExtras
                      .filter((item) => {
                        const id = Number(item.optdet_id ?? item.optitem_id);
                        return paidExtraChecked[id] === true;
                      })
                      .map((item) => {
                        const id = Number(item.optdet_id ?? item.optitem_id);
                        const quantity = Number(selectedPaidExtras[id] || 1);
                        const itemName =
                          item.name ||
                          item.optitem_name ||
                          item.optdet_name ||
                          "";
                        const baseTotal = getPaidExtraBaseTotal(item);
                        const itemTotal = baseTotal * quantity;

                        return (
                          <tr key={`extra-${id}`}>
                            <td colSpan="2" className="tbltxtnew">
                              {itemName}
                              {quantity > 1 && ` x ${quantity}`}
                            </td>
                            <td className="tbltxtnew" align="right">
                              {itemTotal.toFixed(2)} €
                            </td>
                          </tr>
                        );
                      })}

                    {/* ITEMIZED PAID INSURANCE */}
                    {paidInsurance
                      .filter((item) => {
                        const id = Number(item.insdtl_id ?? item.insitem_id);
                        return paidInsuranceChecked[id] === true;
                      })
                      .map((item) => {
                        const id = Number(item.insdtl_id ?? item.insitem_id);
                        const itemName = item.name || "";
                        const itemTotal = getPaidInsuranceBaseTotal(item);

                        return (
                          <tr key={`insurance-${id}`}>
                            <td colSpan="2" className="tbltxtnew">
                              {itemName}
                            </td>
                            <td className="tbltxtnew" align="right">
                              {itemTotal.toFixed(2)} €
                            </td>
                          </tr>
                        );
                      })}

                    <tr>
                      <td colSpan="2" className="priceh2">
                        {rt("ratechart13", "Total extra charges")}
                      </td>

                      <td
                        align="right"
                        style={{
                          color: "indianred",
                        }}
                      >
                        <strong>{totalExtraCharges.toFixed(2)} €</strong>
                      </td>
                    </tr>

                    {/* COUPON DISCOUNT */}

                    {couponDiscountAmount > 0 && (
                      <tr>
                        <td
                          colSpan="2"
                          className="priceh2"
                          style={{
                            color: "#0a9311",
                          }}
                        >
                          <strong>Coupon Discount</strong>

                          {/* {appliedCoupon?.code && <> ({appliedCoupon.code})</>} */}

                          {couponDiscountPercentage > 0 && (
                            <strong
                              style={{
                                fontSize: "13px",
                                marginLeft: "8px",
                              }}
                            >
                              ({couponDiscountPercentage}%)
                            </strong>

                          )}
                          &nbsp;(Of {rt("ratechart10", "Total rental price")})
                        </td>

                        <td
                          align="right"
                          className="priceh2"
                          style={{
                            color: "#0a9311",
                          }}
                        >
                          <strong>- € {couponDiscountAmount.toFixed(2)}</strong>
                        </td>
                      </tr>
                    )}

                    {/* FINAL TOTAL */}

                    <tr className="f-bgc">
                      <td colSpan="2" className="pricehl">
                        <strong>
                          {rt("ratechart14", "Final total rental price")}
                        </strong>
                      </td>

                      <td align="right" style={{ whiteSpace: "nowrap" }}>
                        {couponDiscountAmount > 0 && (
                          <span
                            style={{
                              textDecoration: "line-through",
                              color: "red",
                              marginRight: "12px",
                              fontWeight: "bolder",
                            }}
                          >
                            {totalBeforeCoupon.toFixed(2)} €
                          </span>
                        )}
                        <strong className="estimatedtotalprice">
                          {finalTotal.toFixed(2)}
                        </strong>{" "}
                        €
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="clearfix"></div>
          </div>

          {/* ==================================================
              FINAL TOTAL
          ================================================== */}

          <div
            style={{
              textAlign: "right",
            }}
          >
            <span
              style={{
                fontSize: "16px",
                fontWeight: 600,
              }}
            >
              {rt("ratechart14", "Final total rental price")}
            </span>{" "}
            <strong
              className="estimatedtotalprice"
              style={{
                fontSize: "22px",
                color: "#1b7ee8",
              }}
            >
              {finalTotal.toFixed(2)} €
            </strong>
          </div>

          {/* ==================================================
              BUTTONS
          ================================================== */}

          <div className="right-but">
            <button
              type="button"
              className="nextbutton rightbut"
              onClick={handlePrevious}
              disabled={submitting}
            >
              {t("bookingengine.bookingengine12", "Go Previous")}
            </button>

            <button
              style={{
                marginLeft: "6px",
              }}
              type="button"
              className="nextbutton1 nextbutton"
              onClick={handleConfirmBooking}
              disabled={submitting}
            >
              {submitting
                ? bt("processing", "Processing...")
                : `${t(
                    "othersnewstatics.othersnewstatic55",
                    "Confirm Booking"
                  )} »`}
            </button>
          </div>

          <div className="clearfix"></div>

          {/* ==================================================
              TERMS MODAL
          ================================================== */}

          {showTermsModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(0,0,0,0.55)",
                zIndex: 99999,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px",
              }}
              onClick={closeTerms}
            >
              <div
                style={{
                  width: "970px",
                  maxWidth: "100%",
                  height: "500px",
                  maxHeight: "90vh",
                  background: "#fff",
                  position: "relative",
                  borderRadius: "4px",
                  boxShadow: "0 5px 25px rgba(0,0,0,0.3)",
                  overflow: "hidden",
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div
                  style={{
                    height: "55px",
                    background: "#f5f5f5",
                    borderBottom: "1px solid #ddd",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 18px",
                  }}
                >
                  <h4
                    style={{
                      margin: 0,
                      fontSize: "18px",
                      fontWeight: 600,
                    }}
                  >
                    {termsContent?.cont_title ||
                      bt("termsConditions", "Terms & Conditions")}
                  </h4>

                  <button
                    type="button"
                    onClick={closeTerms}
                    style={{
                      border: "none",
                      background: "transparent",
                      fontSize: "28px",
                      lineHeight: "1",
                      cursor: "pointer",
                      color: "#555",
                    }}
                  >
                    ×
                  </button>
                </div>

                <div
                  style={{
                    height: "calc(100% - 55px)",
                    overflowY: "auto",
                    padding: "20px",
                    fontSize: "14px",
                    lineHeight: "1.6",
                  }}
                >
                  {termsLoading ? (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "50px 20px",
                      }}
                    >
                      {bt("loading", "Loading...")}
                    </div>
                  ) : termsContent ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: termsContent.cont_details || "",
                      }}
                    />
                  ) : (
                    <div
                      style={{
                        textAlign: "center",
                        padding: "50px 20px",
                        color: "#777",
                      }}
                    >
                      {bt(
                        "termsNotAvailable",
                        "Terms & Conditions are not available."
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="clearfix"></div>
      </div>
    </div>
  );
}

export default BookACarThree;
